import { Grid, InputAdornment } from '@material-ui/core';
import { Button, StandardDialog, TextField } from '@roc/ui';
import { observer } from 'mobx-react';
import { useEffect, useState } from 'react';

interface IMakeAnAdjustmentModalProps {
  open: boolean;
  record: any;
  onClose: () => void;
  onSubmit: (amount: number, notes: string) => Promise<void>;
}

export const MakeAnAdjustmentModal = observer(({ open, record, onClose, onSubmit }: IMakeAnAdjustmentModalProps) => {
  const [amount, setAmount] = useState<string>('');
  const [notes, setNotes] = useState('');

  useEffect(() => {
    if (open) {
      setNotes(record?.comment ?? '');
      setAmount(record?.adjustment ?? 0);
    }
  }, [open]);

  const handleClose = () => {
    setAmount('');
    setNotes('');
    onClose();
  };

  const handleSubmit = async () => {
    await onSubmit(Number(amount), notes);
    handleClose();
  };

  return (
    <StandardDialog
      open={open}
      title="Make an Adjustment"
      subTitle="This will be substracted from the original amount."
      maxWidth="sm"
      handleClose={handleClose}
      dialogContent={

        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              label="Invoice"
              testId="adjustment-invoice"
              variant="outlined"
              standaloneLabel
              fullWidth
              value={record?.invoice ?? ''}
              disabled
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="Amount"
              testId="adjustment-amount"
              variant="outlined"
              standaloneLabel
              fullWidth
              type="number"
              value={amount}
              onChange={e => setAmount(e.target.value)}
              InputProps={{
                startAdornment: <InputAdornment position="start">$</InputAdornment>
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="Reference ID / Reason"
              testId="adjustment-notes"
              variant="outlined"
              placeholder='Enter reference ID or reason'
              standaloneLabel
              fullWidth
              multiline
              minRows={3}
              value={notes}
              onChange={e => setNotes(e.target.value)}
            />
          </Grid>
        </Grid>
      }
      dialogActions={
        <>
          <Button
            style={{ marginRight: '8px' }}
            onClick={handleClose}
            color="primary"
            variant="outlined"
            testId="adjustment-cancel"
          >
            Cancel
          </Button>
          <Button
            onClick={handleSubmit}
            color="primary"
            variant="contained"
            testId="adjustment-submit"
            disabled={!record?.invoice || amount === '' || amount === '-'}
          >
            Make Adjustment
          </Button>
        </>
      }
    />
  );
});
